"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFeatureEnabled = isFeatureEnabled;
const evaluateRule_1 = require("./evaluateRule");
const featureFlagsHolderObject_1 = require("./featureFlagsHolderObject");
const getFeatureFlagConfig_1 = require("./getFeatureFlagConfig");
function isFeatureEnabled(component, flag, context) {
    var _a, _b, _c;
    const variants = (_b = (_a = (0, getFeatureFlagConfig_1.getFeatureFlagConfig)()) === null || _a === void 0 ? void 0 : _a[component]) === null || _b === void 0 ? void 0 : _b[flag];
    if (variants) {
        for (const variant of variants) {
            try {
                if (!variant.rule || (0, evaluateRule_1.evaluateRule)(variant.rule, context !== null && context !== void 0 ? context : featureFlagsHolderObject_1.featureFlagsHolderObject.context)) {
                    return variant.enabled;
                }
            }
            catch (error) {
                (_c = featureFlagsHolderObject_1.featureFlagsHolderObject.logRuleEvaluationError) === null || _c === void 0 ? void 0 : _c.call(featureFlagsHolderObject_1.featureFlagsHolderObject, { error, variant, context: context !== null && context !== void 0 ? context : featureFlagsHolderObject_1.featureFlagsHolderObject.context });
            }
        }
    }
    return false;
}
